<header class="header">
    <a class="header__logo" routerLink="/"></a>
    <a class="header__burger" (click)="toggleSidenav()"><i class="ico-menu"></i></a>
    <swb-header-breadcrumbs></swb-header-breadcrumbs>
    <nav class="header__account">
        <a (click)="logout()" class="header__account__logout"><i class="header__account__logout__icon ico-logout"></i></a>
        <swb-header-notifications></swb-header-notifications>
        <a class="header__account__user" [routerLink]="['/user']" routerLinkActive="header__account__user--active">
            <div class='header__account__user__img' [ngStyle]="{'background-image': user.file ? 'url(\'' + imgPrefix + user.file.file_fullname + '\')' : 'none'}">
                <ng-container *ngIf="!user.file">{{ user.username | slice:0:1 }}</ng-container>
            </div>
            <strong class="header__account__user__name">{{ user.username }}</strong>
        </a>
    </nav>
    <a class="header__showweb" [attr.href]="frontUrl" target="_blank">Zobrazit web <span class="ico-angle-right"></span></a>
</header>